export class Company {
    id: number;
    code: string;
    name: string;
    state: any;
}